export default "__VITE_ASSET__DlBL$eMH__"